export const highlightMixin = {
  methods: {
    highlight(completeString, valueToHighlight) {
      if (!valueToHighlight) {
        return completeString;
      }

      // Fix for regex error:
      valueToHighlight = valueToHighlight
        .replace("(", "\\(")
        .replace(")", "\\)");

      return completeString.replace(new RegExp(valueToHighlight, "ig"), x => {
        return `<b>${x}</b>`;
      });
    }
  }
};
